import { defineStore } from "pinia";
const CURRENT_USER_PATH = "/current-user";
export const useCurrentUser = defineStore("current-user", {
    state: () => ({
        userId: -1,
        fullPhotoUrl: "",
        displayName: "",
        thumbnails: {},
        admin: false
    }),
    actions: {
        onLoad(currentUser) {
            this.userId = currentUser.userId;
            this.displayName = currentUser.displayName;
            this.fullPhotoUrl = currentUser.fullPhotoUrl;
            this.thumbnails = currentUser.thumbnails;
            this.admin = currentUser.admin;
            return currentUser;
        },
        load() {
            console.error("Context data could not be loaded from page.");
            return Promise.resolve({});
        }
    },
    loadable: {
        action: "load",
        autoload: true,
        reloadable: true,
        fromPage: {
            key: CURRENT_USER_PATH,
            onLoad: "onLoad"
        }
    }
});
